
export default function Founders() {
  return (
    <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Image */}
          <div className="relative">
            <div className="relative z-10">
              <img
                src="https://static.readdy.ai/image/4bccfbc3b25f334801db453be76bfe26/aa6a9d494c5c346bfc2724de4ea6e8b7.png"
                alt="Media Components Founders - Pipeline Amp Contractors Certified"
                className="w-full h-auto max-w-lg mx-auto"
              />
            </div>
            {/* Decorative elements */}
            <div className="absolute -bottom-4 -left-4 w-72 h-72 bg-red-500/10 rounded-full blur-3xl"></div>
            <div className="absolute -top-4 -right-4 w-48 h-48 bg-black/5 rounded-full blur-2xl"></div>
          </div>

          {/* Content */}
          <div className="lg:pl-8">
            <span className="inline-block px-4 py-1.5 bg-red-500/10 text-red-600 text-sm font-semibold rounded-full mb-4">
              Meet the Team
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-black mb-6">
              Industry-Certified Marketing Experts
            </h2>
            <p className="text-gray-600 text-lg mb-6 leading-relaxed">
              Our founders bring decades of combined experience in contractor marketing. 
              As Pipeline Amp Certified professionals, we understand the unique challenges 
              home service businesses face and deliver proven strategies that generate real results.
            </p>
            <ul className="space-y-4 mb-8">
              <li className="flex items-start gap-3">
                <div className="w-6 h-6 flex items-center justify-center bg-red-500 rounded-full flex-shrink-0 mt-0.5">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <span className="text-gray-700">Specialized in contractor and home service marketing</span>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-6 h-6 flex items-center justify-center bg-red-500 rounded-full flex-shrink-0 mt-0.5">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <span className="text-gray-700">Pipeline Amp Certified for industry best practices</span>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-6 h-6 flex items-center justify-center bg-red-500 rounded-full flex-shrink-0 mt-0.5">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <span className="text-gray-700">Proven track record with 500+ satisfied clients</span>
              </li>
            </ul>
            <a
              href="/about"
              className="inline-flex items-center gap-2 px-6 py-3 bg-red-600 text-white font-semibold rounded-lg hover:bg-red-700 transition-colors cursor-pointer whitespace-nowrap"
            >
              Learn More About Us
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
